var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "url(#paint0_linear_120_12)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 10.9401L10.9401 5.33329",
    stroke: "url(#paint1_linear_120_12)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9402 10.9401L5.33335 5.33329",
    stroke: "url(#paint2_linear_120_12)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_12",
    x1: 4.3131e-8,
    y1: 8.39344,
    x2: 15.8612,
    y2: 8.34962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303D8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_120_12",
    x1: 5.70419,
    y1: 11.3111,
    x2: 11.1381,
    y2: 5.63381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303D8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_120_12",
    x1: 10.5692,
    y1: 11.3111,
    x2: 5.13538,
    y2: 5.63381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303D8C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7577aeff5b6e2e9778b48903dc21a875.svg";
export { ForwardRef as ReactComponent };